import React from "react";
import { Switch, Route } from "react-router-dom";
import { Navbar } from "components/Navbar";
import { AuthContext } from "auth";
import { CategoryList } from "category";
import { ProgramList, ProgramForm, ProgramDetails } from "program";
import { Shelf, HighlightForm, HighlightDetails } from "shelf";
import {
  Shelf as SeriesShelf,
  HighlightForm as SeriesHighlightForm,
  HighlightDetails as SeriesHighlightDetails,
} from "seriesShelf";
import { ChannelList } from "channel";
import { EpisodeList } from "episode";

export function App() {
  const authContext = React.useContext(AuthContext);

  return (
    <div className="App">
      <Navbar logout={authContext.logout}></Navbar>
      <div className="max-w-7xl mx-auto sm:px-6 lg:px-8">
        <Switch>
          <Route path="/categories">
            <CategoryList></CategoryList>
          </Route>
          <Route path="/broadcast-channels">
            <ChannelList></ChannelList>
          </Route>
          <Route path="/series/:id">
            <SeriesHighlightDetails></SeriesHighlightDetails>
          </Route>
          <Route path="/series">
            <SeriesHighlightForm></SeriesHighlightForm>
          </Route>
          <Route path="/series-shelf">
            <SeriesShelf />
          </Route>
          <Route path="/highlight/:id">
            <HighlightDetails></HighlightDetails>
          </Route>
          <Route path="/highlight">
            <HighlightForm></HighlightForm>
          </Route>
          <Route path="/shelf">
            <Shelf />
          </Route>
          <Route path="/program/:id/episodes">
            <EpisodeList></EpisodeList>
          </Route>
          <Route path="/program/:id">
            <ProgramDetails></ProgramDetails>
          </Route>
          <Route path="/create-program">
            <ProgramForm></ProgramForm>
          </Route>
          <Route path="/">
            <ProgramList></ProgramList>
          </Route>
        </Switch>
      </div>
    </div>
  );
}
